// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var BrowserComponents_Subtext = require("./BrowserComponents_Subtext.bs.js");

function container(isShowing) {
  return Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, /* OpenSans */1, /* Medium */3, undefined)({
                  hd: BrowserStyle.color({
                        TAG: /* Red */5,
                        _0: /* Medium */2
                      }),
                  tl: {
                    hd: BrowserStyle.height(BrowserStyle.rem(1.0)),
                    tl: {
                      hd: BrowserStyle.margin2(BrowserStyle.rem(0.5), BrowserStyle.zero),
                      tl: {
                        hd: BrowserStyle.display(isShowing ? "inherit_" : "none"),
                        tl: /* [] */0
                      }
                    }
                  }
                }));
}

var Styles = {
  container: container
};

function BrowserComponents_ValidationError(Props) {
  var className = Props.className;
  var validationResult = Props.validationResult;
  var msg = Relude_Option.fold("", Relude_Globals.id, Curry._2(Relude_Option.flatMap, Relude_Result.getError, validationResult));
  return React.createElement(BrowserComponents_Subtext.make, {
              className: BrowserStyle.Utils.extendBaseStyle(container(Relude_String.isNonWhitespace(msg)), className),
              children: msg
            });
}

var StyleTypes;

var Subtext;

var make = BrowserComponents_ValidationError;

exports.StyleTypes = StyleTypes;
exports.Subtext = Subtext;
exports.Styles = Styles;
exports.make = make;
/* react Not a pure module */
